import { useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';

export const IframeModeContext = createNamedContext<{ iframeMode: boolean }>('IframeModeContext', {
  iframeMode: false,
});

export const useIframeModeContext = () => useContext(IframeModeContext);
